<template>

    <master-panel
            @edit:client="onClientEdit"
            @appointment:cancel="onAppointmentCancel"
            @attention:start="onAttentionStart"
            @attention:end="onAttentionEnd"
            @change:events="onEventsChange"
    >

        <template v-slot:summary="data">
            <v-flex v-if="!!psychologicalRecord" xs12 text-right mt-3 mb-0>
                <v-chip color="success"  dark v-if="psychologicalRecord.last_session && psychologicalRecord.session_number !== 0">
                    <v-icon size="18" class="mr-2">fa-check-circle</v-icon>
                    Alta
                </v-chip>
                <v-chip color="black"  dark>
                    <v-icon size="18" class="mr-2">fa-calendar-check</v-icon>
                    {{sessionName}}
                </v-chip>
            </v-flex>
            <attention-summary v-if="eventDetails" :event="eventDetails" style="border-radius: 10px" class="mt-2 text-left"/>
        </template>

        <template v-slot:body="data">

            <div v-if="eventDetails">

                <v-flex xs12 text-right mt-3 mb-0>
                    <v-chip color="black"  dark>
                        <v-icon size="18" class="mr-2">fa-calendar-check</v-icon>
                        {{sessionName}}
                    </v-chip>
                </v-flex>

                <v-card class="kim-card mt-2">

                    <v-card-text>

                        <template v-if="!psychologicalRecord || (psychologicalRecord && psychologicalRecord.session_number === 0)">
                            <first-date
                                :event="eventDetails"
                                @change:technical_reason="technical_reason = $event"
                                @change:relevant_health_info="relevant_health_info = $event"
                                @change:relevant_school_info="relevant_school_info = $event"
                                @change:relevant_family_info="relevant_family_info = $event"
                                @change:clinical_comments="clinical_comments = $event"
                                @change:indications="indications = $event"
                            />
                        </template>

                        <template v-if="psychologicalRecord && psychologicalRecord.session_number > 0">
                            <client-history-title
                                    title="Observaciones"
                                    icon="fas fa-comment" />

                            <v-divider class="my-2"></v-divider>

                            <v-textarea
                                    v-model="session_comments"
                                    auto-grow rows="2" filled
                                    placeholder="Escribe algo..."
                            />
                        </template>

                    </v-card-text>
                </v-card>

            </div>
        </template>


    </master-panel>

</template>

<script>

    import {ApiUtils} from '@/utils/ApiUtils'
    import {debounce} from '@/utils/Common'

    import {mapMutations, mapState} from 'vuex'

    import MasterPanel from './MasterPanel'
    import AttentionScreenMixin from '@/mixins/AttentionScreenMixin'

    import KimsaFloatingMenu from '@/components/common/KimsaFloatingMenu'
    import BranchOfficeSelect from '@/components/common/panel/BranchOfficeSelect'
    import AttentionSummary from '@/components/appointments/attention/AttentionSummary'

    import FirstDate from './psychology_widgets/FirstDate'

    export default{
        components: {
            FirstDate,
            MasterPanel,
            KimsaFloatingMenu,
            BranchOfficeSelect,
            AttentionSummary
        },
        mixins: [AttentionScreenMixin],
        data(){
            return {
                technical_reason: '',
                relevant_health_info: '',
                relevant_school_info: '',
                relevant_family_info: '',
                session_number: 0,
                session_comments: '',
                clinical_comments: '',
                indications: '',
            }
        },
        mounted(){
          var vm = this
            vm.setDefaults()
        },
        methods: {
                ...mapMutations('clientAttention', ['setGlobalSaving']),
            setDefaults(){

                var vm = this
                if(!vm.psychologicalRecord) return

                vm.technical_reason = vm.psychologicalRecord.technical_reason
                vm.relevant_health_info = vm.psychologicalRecord.relevant_health_info
                vm.relevant_school_info = vm.psychologicalRecord.relevant_school_info
                vm.relevant_family_info = vm.psychologicalRecord.relevant_family_info
                vm.session_number = vm.psychologicalRecord.session_number
                vm.session_comments = vm.psychologicalRecord.session_comments
                vm.clinical_comments = vm.psychologicalRecord.clinical_comments
                vm.indications = vm.psychologicalRecord.indications

            },
            onCommentUpdate(comment){
                var vm = this
                if(!vm.eventDetails || !vm.eventDetails.anamnesis) return
                vm.eventDetails.anamnesis.comment = comment
            },
            debouncedSave: debounce(function(){
                this.save()
            }, 1000),
            async save(){

                var vm = this
                if(vm.saving) return

                vm.setGlobalSaving(true)
                const response = await ApiUtils.makePatch(
                        `appointment/${vm.eventDetails.id}/attention/psychological-record`,
                        null,
                        vm.payload
                )
                vm.setGlobalSaving(false)
                vm.eventDetails.psychological_record = Object.assign({}, vm.eventDetails.psychological_record , vm.payload)
            }
        },
        computed: {
            ...mapState('clientAttention', {
                saving: state => state.globalSaving
            }),
            payload(){
                var vm = this
                return {
                    technical_reason: vm.technical_reason,
                    relevant_health_info: vm.relevant_health_info,
                    relevant_school_info: vm.relevant_school_info,
                    relevant_family_info: vm.relevant_family_info,
                    session_comments: vm.session_comments,
                    clinical_comments: vm.clinical_comments,
                    indications: vm.indications,
                }
            },
            sessionName(){
                var vm = this
                if(!vm.psychologicalRecord || vm.psychologicalRecord.session_number === 0){
                    return 'Primera cita'
                }

                return `Sesión ${vm.psychologicalRecord.session_number}`

            },
            psychologicalRecord(){
                var vm = this
                return vm.eventDetails && vm.eventDetails.psychological_record || null
            }
        },
        watch:{
            eventDetails(val){
              this.setDefaults()
            },
            payload(val){
                var vm = this
                vm.debouncedSave()
            }
        }
    }
</script>

<style scoped>

</style>
